<div class="sunset-overlay">
  <div class="sunset-modal">
    <div class="sunset-modal-icon">
      <lucide-icon [img]="AlertTriangle" [size]="36" />
    </div>
    <h2 class="sunset-modal-title">This environment has moved</h2>
    <p class="sunset-modal-body">
      The migration is complete and this environment is now closed. All work now happens on the new
      site.
    </p>
    <ul class="sunset-modal-list">
      <li>
        Tasks created
        <strong>before April 14, 2026</strong>
        have been archived and are accessible by admins.
      </li>
    </ul>
    <p class="sunset-modal-help">
      For issues, contact your local site admin or submit an SLHS ticket for assistance.
    </p>
    <div class="sunset-modal-actions">
      <a class="sunset-modal-btn sunset-modal-btn--primary" [href]="newSiteUrl">
        Go to the new site now
      </a>
      <p class="sunset-modal-countdown">Redirecting automatically in {{ countdown() }}s&hellip;</p>
    </div>
  </div>
</div>
